import React, { useContext, useEffect } from "react";
import Header from "../../components/Header";
import Table from "react-bootstrap/Table";
import Sidebar from "../../components/Sidebar";
import { ProfileContext } from "../../context/ProfileContext";
import Loader from "../../components/Loader";

function CallHistory() {
  const { callHistory, getCallHistory, callHistoryPagination, isLoading } = useContext(ProfileContext);

  useEffect(() => { getCallHistory(1, 'all') }, []);

  const handleNext = () => {
    if (callHistoryPagination && callHistoryPagination.currentPage < callHistoryPagination.totalPages) {
      getCallHistory(callHistoryPagination.currentPage + 1, 'all');
    }
  };

  const handlePrevious = () => {
    if (callHistoryPagination && callHistoryPagination.currentPage > 1) {
      getCallHistory(callHistoryPagination.currentPage - 1, 'all');
    }
  };

  const getPaginationText = () => {
    if (!callHistoryPagination || callHistoryPagination.totalCount === 0) return "";
    const start = (callHistoryPagination.currentPage - 1) * callHistoryPagination.limit + 1;
    const end = Math.min(callHistoryPagination.currentPage * callHistoryPagination.limit, callHistoryPagination.totalCount);
    return `${start}-${end} of ${callHistoryPagination.totalCount} items`;
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex justify-content-between align-items-center">
                <h6 className="comm_page_heading">Price Usage History</h6>
                <p className="comm_page_sub_heading">Monitor HeyGen avatar call usage details per user.</p>
              </div>

              <div className="comm-table mt-4 pt-0">
                {callHistory && callHistory.length > 0 ? (
                  <Table responsive hover className="align-middle">
                    <thead>
                      <tr className="head-class-td">
                        <th>Sr. no.</th>
                        <th>Patient ID</th>
                        <th>Patient Details</th>
                        <th>Total Calls</th>
                        <th>Total Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {callHistory.map((user, index) => (
                        <tr key={user._id}>
                          <td>{(callHistoryPagination.currentPage - 1) * callHistoryPagination.limit + index + 1}</td>
                          <td className="id_txt">{user.patient_id ? `#${user.patient_id}` : "N/A"}</td>
                          <td>
                            <div className="d-flex flex-column">
                              <span className="fw-bold">{user.full_name}</span>
                              <small className="text-muted">{user.email}</small>
                            </div>
                          </td>
                          <td><span className="badge bg-light text-dark">{user.hygenCallCount || 0}</span></td>
                          <td className="fw-bold text-success">${user.totalPrice?.toFixed(2) || "0.00"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>)
                  :
                  (<div className="text-center mt-5 py-5 border rounded bg-light">
                    <h2 className="text-muted">No Call History Found !!</h2>
                  </div>)
                }
              </div>

              {callHistoryPagination && callHistoryPagination.totalCount > 10 && (
                <div className="d-flex table_bottom_row">
                  <h4 className="page_count_txt">{getPaginationText()}</h4>
                  <div className="d-flex btn_grp">
                    <button
                      className="table_bott_btn"
                      onClick={handlePrevious}
                      disabled={callHistoryPagination.currentPage <= 1}
                    >
                      Previous
                    </button>
                    <button
                      className="table_bott_btn"
                      onClick={handleNext}
                      disabled={callHistoryPagination.currentPage >= callHistoryPagination.totalPages}
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default CallHistory;
